import * as types from './types';
import * as samples from './samples';

const Constants = { ...types, ...samples };

export default Constants;
